import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ColorPickerInput } from './../../../models';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
    selector: 'lib-color-picker-input',
    imports: [CommonModule, ColorPickerModule, FormsModule, ReactiveFormsModule],
    standalone: true,
    templateUrl: './color-picker-input.component.html',
    styleUrl: './color-picker-input.component.scss'
})
export class ColorPickerInputComponent extends BaseInputComponent {
    @Input() name!: string;
    @Input() override control!: ColorPickerInput;

    /**
     * da shadow input a form control
     *
     * @param $event
     */
    hexChanges($event: string) {
        this.control.markAsDirty();
        this.control.setValue($event);
        this.control.updateValueAndValidity({ emitEvent: true });
    }
}
